// Helpers / labels for import jobs + staging rows.

export const JOB_STATUSES = [
  { value: 'queued', label: 'Queued', badge: 'status-draft' },
  { value: 'running', label: 'Running', badge: 'status-review' },
  { value: 'succeeded', label: 'Succeeded', badge: 'status-published' },
  { value: 'failed', label: 'Failed', badge: 'status-archived' },
  { value: 'cancelled', label: 'Cancelled', badge: 'status-archived' },
];

export const ROW_STATUSES = [
  { value: 'staged', label: 'Staged', badge: 'status-draft' },
  { value: 'approved', label: 'Approved', badge: 'status-review' },
  { value: 'rejected', label: 'Rejected', badge: 'status-archived' },
  { value: 'applied', label: 'Applied', badge: 'status-published' },
  { value: 'failed_apply', label: 'Failed apply', badge: 'status-archived' },
];

export function jobStatusMeta(value) {
  return JOB_STATUSES.find((s) => s.value === value) || { value, label: value, badge: 'status-draft' };
}

export function rowStatusMeta(value) {
  return ROW_STATUSES.find((s) => s.value === value) || { value, label: value, badge: 'status-draft' };
}

export function targetTypeLabel(t) {
  if (t === 'supervisor_of_elections') return 'Supervisor of Elections';
  if (t === 'election_dates') return 'Election Dates';
  return t || '—';
}
